import { DashboardCanvas } from '@/components/dashboard/DashboardCanvas';
import { DashboardDateControl } from '@/components/dashboard/DashboardDateControl';
import { dashboardRangeKey } from '../../../../../dashboard/hooks';
import { resolveDashboardWidgetRange } from '../../../../../dashboard/dateRange';
import { defaultIntegrationDashboardDocument } from '../../../dashboard/defaultIntegrationDashboard';
import { useIntegrationDashboardQueries } from '../../../dashboard/hooks';
import type { IntegrationDashboardDocument } from '../../../dashboard/widgetModel';
import { integrationDashboardWidgetRegistry } from '../../../dashboard/widgetRegistry';
import { useIntegrationDashboardRouteFilters } from '../../../dashboard/useIntegrationDashboardRouteFilters';

export function IntegrationOverview({
  integrationId,
  document = defaultIntegrationDashboardDocument,
}: {
  integrationId: string;
  document?: IntegrationDashboardDocument | undefined;
}) {
  const { range, setRange } = useIntegrationDashboardRouteFilters();
  const widgetRangesById = document.widgets.map((widget) => ({
    id: widget.id,
    range: resolveDashboardWidgetRange(widget.dateScope, range),
  }));
  const widgetRanges = widgetRangesById.map(({ range: widgetRange }) => widgetRange);
  const queriesByRangeKey = useIntegrationDashboardQueries(integrationId, widgetRanges);
  const rangesByWidgetId = new Map(
    widgetRangesById.map(({ id, range: widgetRange }) => [id, widgetRange]),
  );

  return (
    <div className="min-w-0 space-y-6">
      <div className="flex flex-wrap items-center justify-end gap-3">
        <DashboardDateControl showDayNavigation value={range} onChange={setRange} />
      </div>
      <DashboardCanvas
        document={document}
        registry={integrationDashboardWidgetRegistry}
        runtime={{ rangesByWidgetId, queriesByRangeKey, rangeKey: dashboardRangeKey }}
      />
    </div>
  );
}
